import { JsonPipe } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ApiService } from 'src/app/Services/api.service';
import { CommonServices } from 'src/app/Services/common.service';
import { MapService } from 'src/app/Services/map.service';
import { RouteService } from 'src/app/Services/route.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

declare var google: any;
@Component({
  selector: 'app-tracking',
  templateUrl: './tracking.component.html',
  styleUrls: ['./tracking.component.css']
})
export class TrackingComponent implements OnInit {
  empAttendanceCond: any;
  @Input() set filterDate(val: any) {
    if (val) {
      this.selFilteredDate = val;
      this.getEmployeeList(val);
    }
  }
  @Input() set branchChoosen(val: any) {
    if (val) {
      this.choosenBranch = val;
      if (this.selFilteredDate == undefined) {
        this.getEmployeeList();
      } else {
        this.getEmployeeList(this.selFilteredDate);
      }
    } else {
      this.choosenBranch = [];
    }
  }
  public fleetData: any = [];
  public selectedEmps: any = [];
  public selectedGroup: any = {};
  public statusUpdateForm: FormGroup;
  public showStatusUpdateForm: boolean = false;
  public statusFormSubmitted: boolean = false;
  public statusList: any = {};
  public isAnyChangesHere: boolean = false;
  public finalObj: any = {};
  public selectedBranch: any = [];
  public branchInformation: any = {};
  public checkInOutID: string = '';
  public updateVehData: any = [];
  public checkInDate: number = 0;
  public storedData: any = [];
  public showFilter: boolean = false;
  public filterForm: FormGroup;
  public endTripForm: FormGroup;
  public selFilteredDate: number;
  public availShifts: any = [];
  public choosenBranch: any = [];
  public modalTitle: string = 'Employee status update';
  @ViewChild('enTripModalBtn') enTripModalBtn: ElementRef;
  @ViewChild('closeModalBtn') closeModalBtn: ElementRef;
  private intervalId: any;
  constructor(
    public api: ApiService,
    public swal: SweetAlert,
    public storage: StorageService,
    private com: CommonServices,
    private mapService: MapService,
    private routeservice: RouteService,
    public formBuilder: FormBuilder
  ) {
    if (this.storage.get('userInfo').branch && this.storage.get('userInfo').branch.length > 0) {
      this.selectedBranch = this.storage.get('userInfo').branch;
    }
    this.getBranchList();
    let generalSettings = this.storage.get('userInfo').general;

    this.empAttendanceCond = generalSettings.hasOwnProperty('empAttendance') && generalSettings['empAttendance']
      ? (generalSettings['empAttendance'])
      : ('both');

  }
  get f() { return this.endTripForm.controls; }
  ngOnInit(): void {
    // this.statusUploadFormLoad();
    this.loadFilterForm();
    this.statusUpdateForm = new FormGroup({});
    // if(this.selFilteredDate==undefined){
    //   setTimeout(()=>{
    //     this.getEmployeeList();
    //   },1000)
    // }
    this.endTripForm = this.formBuilder.group({
      tripEndKlMtr: ['', Validators.required]
    })
    this.startInterval();
  }
  loadFilterForm() {
    this.filterForm = new FormGroup({
      empRefID: new FormControl(''),
      vehRegNo: new FormControl(''),
      shiftTime: new FormControl('')
    })
    this.showFilter = true;
  }
  getBranchList() {
    let data = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(data).then((res: any) => {
      if (res && res.status == 'success' && res.data && res.data.length > 0) {
        for (let i = 0; i < res.data.length; i++) {
          this.branchInformation[res.data[i]['branchID']] = res.data[i]['branchName'];
        }
        if (this.selectedBranch == undefined || this.selectedBranch.length <= 0) {
          this.selectedBranch = Object.keys(this.branchInformation)
        }
        this.getVehicleCheckInList();
      } else {
        this.selectedBranch = [];
        this.branchInformation = {};
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getVehicleCheckInList() {
    const obj = {
      "branch": this.choosenBranch,
      "type": ["out", "in"],
    };
    this.api.transportManagerCheckInOutList(obj).then((res: any) => {
      if (res && res.status == 'success') {
        if (res['data'] && res['data'].length > 0) {
          this.updateVehData = res['data'];
          // this.checkInOutID=res['data'][0]['checkInOutID'];
        } else {
          this.checkInOutID = '';
          this.updateVehData = [];
        }
      } else {
        this.checkInOutID = '';
        this.updateVehData = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getEmployeeList(date?) {
    let apiObj = {
      rosterStatus: ['Fleet management']
    };
    apiObj['branchID'] = this.choosenBranch;
    // if(date){
    //   apiObj['tripDate']=date;
    // }else{
    //   apiObj['tripDate']=new Date(this.com.timestampToDate(new Date().getTime(),'YMD','-')).getTime();
    // }
    let currentDate = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
    if (this.selFilteredDate == undefined || this.selFilteredDate == currentDate) {
      apiObj['tripDate'] = new Date(this.com.timestampToDate(new Date().getTime(), 'YMD', '-')).getTime();
      apiObj['istoday'] = true;
    } else {
      apiObj['tripDate'] = this.selFilteredDate;
      apiObj['istoday'] = false;
    }
    this.api.transportManagerGrouping(apiObj).then(async (res: any) => {
      if (res && res.status == 'success') {
        if (res.data[0]['fleetManagment'] && res.data[0]['fleetManagment'].length > 0) {
          this.fleetData = await this.com.sortGroupByShiftTime(res.data[0]['fleetManagment'].filter(e => e.tripStatus == 'start' || (e.tripStatus == 'end' && !this.filterDataByStatus(e.empInfo, e))), 'shiftTime');
          this.storedData = JSON.parse(JSON.stringify(res.data[0]['fleetManagment'].filter(e => e.tripStatus == 'start' || (e.tripStatus == 'end' && !this.filterDataByStatus(e.empInfo, e)))));
        } else {
          this.fleetData = [];
        }
        if (this.storedData.length > 0) {
          let arr = [];
          for (let i = 0; i < this.storedData.length; i++) {
            if (this.storedData[i]['shiftTimeStr'] != undefined) arr.push(this.storedData[i]['shiftTimeStr']);

          }
          this.availShifts = this.removeDuplicateString(arr);
        } else {
          this.availShifts = [];
        }
      } else {
        this.fleetData = [];
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  removeDuplicateString(arr) {
    return arr.filter((item,
      index) => arr.indexOf(item) == index);
  }
  filterDataByStatus(data, e) {
    if (data?.length > 0 && e?.routeType == undefined) {
      let isValid = false;
      for (let i = 0; i < data?.length; i++) {
        if (data[i]['empTripStatus']) {
          isValid = true;
        } else {
          isValid = false;
          break;
        }
      }
      return isValid;
    } else if (['regular', 'openBooking', 'occasional'].includes(e?.routeType) && data == undefined) {
      let isValid = false;
      if (e.tripStatus == 'start') {
        isValid = false;
      } else {
        isValid = true;
      }
      return isValid;
    }
  }
  public statusCheckError = (controlName: string, errorName: string) => {
    return this.statusUpdateForm.controls[controlName].hasError(errorName);
  }
  public showEmpTable: boolean = false;
  findSelectedVeh(data) {
    return new Promise((res, rej) => {
      let filData = this.updateVehData.filter(e => e.vehRegNo == data.vehRegNo);
      res(filData);
    })
  }
  public selectedGroupIndex = -1;
  async openModal(index) {
    this.selectedGroupIndex = index;
    this.showEmpTable = true;
    this.fleetData = this.storedData;
    let data = this.fleetData[index];
    this.selectedGroup = data;
    this.selectedEmps = data?.empInfo;
    let vehData: any = await this.findSelectedVeh(data);
    this.finalObj = {
      type: 'Fleet management',
      tripDate: data?.tripDate,
      rosterID: data?.rosterID,
      vehRegNo: data?.vehRegNo,
      routeID: data?.routeID,
      transitMode: data?.transitMode,
      branchInfo: data?.branchInfo
    }
    if (vehData && vehData?.length > 0) {
      this.finalObj['date'] = vehData[0]['checkIn']['date'];
      this.finalObj['checkInID'] = vehData[0]['checkIn']['checkInID'];
    }
    this.showStatusUpdateForm = true;

    this.statusList = {
      // "boarded": "Boarded",
      "reschedule": "Reschedule",
      "noShow": "No show",
      "noNeed": "No need",
      // "deboarded": "Deboarded",
    }

    if (this.empAttendanceCond == 'single') {
      this.statusList[data?.transitMode?.toLowerCase() === 'pickup' ? 'boarded' : 'deboarded'] = data?.transitMode?.toLowerCase() === 'pickup' ? 'Boarded' : 'Deboarded';
    } else if (this.empAttendanceCond == 'both') {
      this.statusList["boarded"] = "Boarded";
      this.statusList["deboarded"] = "Deboarded";
    }

    this.statusUploadToForm();
    setTimeout(() => {
      this.setValuesToForm(data);
    }, 100)
    document.getElementById('openStatusUpdateModalBtn')?.click();
  }
  statusUploadToForm() {
    for (let i = 0; i < this.selectedEmps?.length; i++) {
      let name = 'empStatus' + this.selectedEmps[i]?.empRefID;
      this.statusUpdateForm.addControl(name, new FormControl(''));
    }
  }
  setValuesToForm(data) {
    for (let i = 0; i < this.selectedEmps?.length; i++) {
      let name = 'empStatus' + this.selectedEmps[i].empRefID;
      let elem: any = document.getElementById(name);
      if (this.selectedEmps[i].empTripStatus) {
        elem.disabled = true;
      }
      if (this.selectedEmps[i].empTripStatus) {
        this.statusUpdateForm.controls[name].patchValue(this.selectedEmps[i].empTripStatus);
      } else {
        this.statusUpdateForm.controls[name].patchValue('');
      }
    }
  }
  changeEmpStatus(id, value) {
    this.isAnyChangesHere = true;
    let name = 'empStatus' + id;
    let index = this.selectedEmps.findIndex(e => e.empRefID == id);
    if (index != -1) {
      this.selectedEmps[index]['empTripStatus'] = value;
      if (value == 'boarded') {
        this.selectedEmps[index]['attenTime'] = Date.now();
        this.selectedEmps[index]['scanTime'] = Date.now();
      } else if (value == 'deboarded') {
        this.selectedEmps[index]['attenExitTime'] = Date.now();
        this.selectedEmps[index]['scanTime'] = Date.now();
      } else if (value == 'reschedule') {
        this.selectedEmps[index]['attenTime'] = Date.now();
        this.selectedEmps[index]['scanTime'] = Date.now();
        this.finalObj['tripType'] = this.selectedGroup['transitMode'];
        this.finalObj['shiftTimeStr'] = this.selectedGroup['shiftTimeStr'];
        this.finalObj['location'] = this.selectedGroup['location'];
        this.finalObj['area'] = this.selectedGroup['area'];
        // this.finalObj['branchInfo']=this.selectedGroup['branchInfo'];
        // if(this.selectedEmps[index]['attenTime']) delete this.selectedEmps[index]['attenTime'];
        if (this.selectedEmps[index]['atten']) delete this.selectedEmps[index]['atten'];
        if (this.selectedEmps[index]['attenExitTime']) delete this.selectedEmps[index]['attenExitTime'];
      } else {
        this.selectedEmps[index]['attenTime'] = Date.now();
        this.selectedEmps[index]['scanTime'] = Date.now();
        // if(this.selectedEmps[index]['attenTime']) delete this.selectedEmps[index]['attenTime'];
        if (this.selectedEmps[index]['atten']) delete this.selectedEmps[index]['atten'];
        if (this.selectedEmps[index]['attenExitTime']) delete this.selectedEmps[index]['attenExitTime'];
      }
      if (['noNeed','noShow'].includes(value)) {
        this.selectedEmps[index]['scanTime'] = Date.now();
        this.finalObj['shiftTimeStr'] = this.selectedGroup['shiftTimeStr'];
        // this.finalObj['branchInfo']=this.selectedGroup['branchInfo'];
      }
      this.selectedEmps[index]['statusNew'] = true;
      this.finalObj['empInfo'] = this.selectedEmps;
    }
  }
  closeModal() {
    if (this.selFilteredDate == undefined) {
      this.getEmployeeList();
    } else {
      this.getEmployeeList(this.selFilteredDate);
    }
    this.showEmpTable = false;
    this.selectedGroup = {};
    this.selectedEmps = [];
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    this.finalObj = {};
    this.resetFilterForm();
  }
  convertTimeStr(ms) {
    let d = new Date(ms),
      h = (d.getHours() < 10 ? '0' : '') + d.getHours(),
      m = (d.getMinutes() < 10 ? '0' : '') + d.getMinutes();
    return h + ':' + m;
  }
  submitModal() {
    this.statusFormSubmitted = true;
    if (this.isAnyChangesHere) {
      this.api.transportManagerEditGrouping(this.finalObj).then((res: any) => {
        if (res && res.status == 'success') {
          this.fleetData = [];
          this.storedData = [];
          this.closeModal();
          if (this.selFilteredDate == undefined) {
            this.getEmployeeList();
          } else {
            this.getEmployeeList(this.selFilteredDate);
          }
          this.swal.swalFunction('success', res.status, res.message, 5000);
          document.getElementById('closeModalBtn')?.click();
          this.finalObj = {};
        } else {
          this.swal.swalFunction('error', res.status, res.message, 5000);
        }
      }).catch((err) => {
        console.log(err);
      });
    }
  }

  //filter
  resetFilterForm() {
    this.filterForm.patchValue({
      empRefID: '',
      vehRegNo: '',
      shiftTime: ''
    })
  }
  filterBySearch(value, field) {
    // let text=value.toLowerCase();
    let formField = this.filterForm.value;
    if (formField.empRefID != '' && formField.vehRegNo != '' && formField.shiftTime != '') {
      let arr = [];
      for (let i = 0; i < this.storedData.length; i++) {
        let matchedEmployees = this.storedData[i]['empInfo']?.filter(e => {
          return e.empRefID.toLowerCase().includes(formField.empRefID.toLowerCase()) ||
            e.name.toLowerCase().includes(formField.empRefID.toLowerCase());
        });

        if (matchedEmployees?.length > 0) {
          let matchedData = { ...this.storedData[i], empInfo: matchedEmployees, showEmp: true };
          arr.push(matchedData);
        }
      }
      if (arr.length > 0) {
        let data = arr.filter(e => e.vehRegNo.toLowerCase().includes(formField.vehRegNo.toLowerCase())
          && e.shiftTimeStr == formField.shiftTime);
        if (data.length > 0) {
          this.fleetData = data;
        } else {
          this.fleetData = [];
        }
      } else {
        this.fleetData = [];
      }
    } else if (formField.empRefID != '' && formField.vehRegNo != '' && formField.shiftTime == '') {
      let arr = [];
      for (let i = 0; i < this.storedData.length; i++) {
        let matchedEmployees = this.storedData[i]['empInfo']?.filter(e => {
          return e.empRefID.toLowerCase().includes(formField.empRefID.toLowerCase()) ||
            e.name.toLowerCase().includes(formField.empRefID.toLowerCase());
        });

        if (matchedEmployees?.length > 0) {
          let matchedData = { ...this.storedData[i], empInfo: matchedEmployees, showEmp: true };
          arr.push(matchedData);
        }
      }
      if (arr.length > 0) {
        let data = arr.filter(e => e.vehRegNo.toLowerCase().includes(formField.vehRegNo.toLowerCase()));
        if (data.length > 0) {
          this.fleetData = data;
        } else {
          this.fleetData = [];
        }
      } else {
        this.fleetData = [];
      }

    } else if (formField.empRefID != '' && formField.vehRegNo == '' && formField.shiftTime != '') {
      let arr = [];
      for (let i = 0; i < this.storedData.length; i++) {
        let matchedEmployees = this.storedData[i]['empInfo']?.filter(e => {
          return e.empRefID.toLowerCase().includes(formField.empRefID.toLowerCase()) ||
            e.name.toLowerCase().includes(formField.empRefID.toLowerCase());
        });

        if (matchedEmployees?.length > 0) {
          let matchedData = { ...this.storedData[i], empInfo: matchedEmployees, showEmp: true };
          arr.push(matchedData);
        }
      }
      if (arr.length > 0) {
        let data = arr.filter(e => e.shiftTimeStr == formField.shiftTime);
        if (data.length > 0) {
          this.fleetData = data;
        } else {
          this.fleetData = [];
        }
      } else {
        this.fleetData = [];
      }

    } else if (formField.empRefID == '' && formField.vehRegNo != '' && formField.shiftTime != '') {
      let data = this.storedData.filter(e => e.vehRegNo.toLowerCase().includes(formField.vehRegNo.toLowerCase())
        && e.shiftTimeStr == formField.shiftTime);
      this.fleetData = data;

    } else if (formField.empRefID != '' && formField.vehRegNo == '' && formField.shiftTime == '') {
      let arr = [];
      for (let i = 0; i < this.storedData.length; i++) {
        let matchedEmployees = this.storedData[i]['empInfo']?.filter(e => {
          return e.empRefID.toLowerCase().includes(formField.empRefID.toLowerCase()) ||
            e.name.toLowerCase().includes(formField.empRefID.toLowerCase());
        });

        if (matchedEmployees?.length > 0) {
          let matchedData = { ...this.storedData[i], empInfo: matchedEmployees, showEmp: true };
          arr.push(matchedData);
        }
      }
      if (arr.length > 0) {
        this.fleetData = arr;
      } else {
        this.fleetData = []
      }

    } else if (formField.empRefID == '' && formField.vehRegNo != '' && formField.shiftTime == '') {
      let data = this.storedData.filter(e => e.vehRegNo.toLowerCase().includes(formField.vehRegNo.toLowerCase()));
      this.fleetData = data;

    } else if (formField.empRefID == '' && formField.vehRegNo == '' && formField.shiftTime != '') {
      let data = this.storedData.filter(e => e.shiftTimeStr == formField.shiftTime);
      this.fleetData = data;

    } else if (formField.empRefID == '' && formField.vehRegNo == '' && formField.shiftTime == '') {
      this.fleetData = this.storedData;
    }
  }

  //Refresh
  refreshTrackingPage() {

    this.resetFilterForm();
    if (this.selFilteredDate == undefined) {
      this.getEmployeeList();
    } else {
      this.getEmployeeList(this.selFilteredDate);
    }
  }

  //Employee view in map
  public selectedMap: string = 'google';
  public googleMapObj: any;
  public locationMap: any;
  public markerId = 'pickLocation' + Math.round(Math.random() * 10000);
  public markersArray: any = [];

  public empLocs: any = [];
  public wayPoints: any = [];
  public routeLine: any;
  public plotPath: any;
  public plottedLines: any = [];
  public lineCoardinate: any = [];

  async viewEmpInMap(group) {
    this.modalTitle = 'Trip details';
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    this.loadMap(group);
    setTimeout(() => {
    }, 10)

  }
  async customiseData(group) {

    let employees = JSON.parse(JSON.stringify(group.empInfo));
    if (group.branchInfo) {
      if (group.transitMode == 'Pickup') {
        employees.push(group.branchInfo);
      } else {
        employees.unshift(group.branchInfo);
      }
    }
    for (let i = 0; i < employees.length; i++) {
      if (employees[i].location && employees[i].location['lat'] && employees[i].location['lng']) {
        if (this.selectedMap == 'google') {
          let obj = {};
          if (employees[i].empRefID) {
            obj = {
              name: employees[i].name,
              ID: employees[i].empRefID,
              mobile: employees[i].mobile,
              type: 'Employee'
            }
            if (group.transitMode == 'Pickup') {
              obj['pp'] = i + 1;
            } else {
              obj['pp'] = i;
            }
          } else {
            obj = {
              name: employees[i].name,
              type: 'Branch'
            }
          }
          let arr = [
            employees[i].location['lat'],
            employees[i].location['lng'],
            { pp: true }
          ]
          this.empLocs.push(arr);
          this.placeMarker(employees[i].location['lat'], employees[i].location['lng'], obj);
        } else {
          this.locationMarker(employees[i].location['lat'], employees[i].location['lng']);
        }
      }
    }
    for (let i = 0; i < this.empLocs.length; i++) {
      if (i > 0) {
        let arr = [this.empLocs[i - 1], this.empLocs[i]];
        let points: any = await this.routeservice.findWayPoints(arr);
        this.wayPoints = [...this.wayPoints, ...points];
      }
    }
    if (this.wayPoints.length > 0) {
      for (let l = 0; l < this.wayPoints.length; l++) {
        let obj = {
          lat: +this.wayPoints[l][0],
          lng: +this.wayPoints[l][1]
        }
        this.lineCoardinate.push(obj);
      }
      for (let m = 0; m < this.lineCoardinate.length; m++) {
        if (m > 0) {
          let arr = [this.lineCoardinate[m - 1], this.lineCoardinate[m]];
          let line = await this.drawLine(arr, m, group.transitMode);
          this.plotPath = line;
          this.plotPath.setMap(this.googleMapObj);
          this.plottedLines.push(line);
        }
      }
    }
  }

  loadMap(group) {
    if (this.selectedMap == 'google') {
      setTimeout(() => {
        const mapOptions = {
          scrollwheel: true,
          zoom: 9,
          maxZoom: 17,
          center: new google.maps.LatLng(13.0843, 80.2705),
          fullscreenControl: false,
          zoomControl: true,
          zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP,
          },
          mapTypeControl: true,
          mapTypeControlOptions: {
            style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
            position: google.maps.ControlPosition.TOP_CENTER,
          },
          streetViewControl: false,
        };
        this.googleMapObj = new google.maps.Map(document.getElementById('locationMap'), mapOptions);
        this.customiseData(group);
      }, 100)
    } else {
      this.mapService.map("locationMap").then((map) => {
        this.locationMap = map;
        this.customiseData(group);
      }).catch((error) => {
        console.log(error)
      });
    }
  }
  closeTripDetails() {
    this.modalTitle = 'Employee status update';
    this.isAnyChangesHere = false;
    this.statusFormSubmitted = false;
    this.openModal(this.selectedGroupIndex);

    if (this.selectedMap == 'google') {
      if (this.markersArray.length > 0) {
        this.clearOverlays();
      }
      if (this.plotPath) {
        this.plotPath.setMap(null);
      }
      this.empLocs = [];
      this.wayPoints = [];
    } else {
      this.locationMap.removeMarkerAll();
    }
    this.lineCoardinate = [];
    if (this.plottedLines.length > 0) {
      for (let i = 0; i < this.plottedLines.length; i++) {
        this.plottedLines[i].setMap(null);
      }
    }
    this.plottedLines = [];
  }

  drawLine(arr, index, transitMode) {
    return new Promise((res, rej) => {
      const lineSymbol = {
        path: google.maps.SymbolPath.FORWARD_CLOSED_ARROW,
        strokeColor: 'black',
        strokeWeight: 2,
        scale: 3
      };
      let line;
      if (index % 5 == 0 && index != 0) {
        line = new google.maps.Polyline({
          path: arr,
          geodesic: true,
          strokeColor: "#0F15C8",
          strokeOpacity: 1.0,
          strokeWeight: 4,
          visible: true,
          icons: [
            {
              icon: lineSymbol,
              offset: "50%",
            },
          ],
        })
      } else {
        line = new google.maps.Polyline({
          path: arr,
          geodesic: true,
          strokeColor: "#0F15C8",
          strokeOpacity: 1.0,
          strokeWeight: 4,
          visible: true,
        })
      }
      res(line);
    })
  }

  placeMarker(lat, lng, emp) {
    let latLng = new google.maps.LatLng(+lat, +lng);
    let image = {
      origin: new google.maps.Point(0, 0),
      scaledSize: new google.maps.Size(50, 50),
    };
    // let marker = new google.maps.Marker({
    //   position: latLng, 
    //   map: this.googleMapObj,
    // });
    let marker;
    if (emp.type == 'Branch') {
      image['url'] = "assets/images/map/branch.png";
      marker = new google.maps.Marker({
        position: latLng,
        map: this.googleMapObj,
        icon: image
      });

    } else {
      marker = new google.maps.Marker({
        position: latLng,
        map: this.googleMapObj,
      });
    }
    let infoWindowContent;
    let infowindow;
    marker.addListener('click', (e) => {
      if (infowindow) infowindow.close();
      if (emp.type == 'Employee') {
        infoWindowContent = '<div class="window-content-container"><div>' + 'Pickup point :' + '<span>' + ' ' + emp.pp + '</span></div><div style="margin-top:2px">' + 'Name :' + '<span>' + ' ' + emp.name + '</span></div><div style="margin-top:2px">' + 'Employee ID :' + ' ' + '<span>' + emp.ID.toUpperCase() + ' ' + '</span>' + '</div><div style="margin-top:2px">' + 'Mobile :' + ' ' + '<span>' + emp.mobile + ' ' + '</span>' + '</div>' + '</div>';
      } else if (emp.type == 'Branch') {
        infoWindowContent = '<div class="window-content-container"><div>' + 'Branch :' + '<span>' + ' ' + emp.name + '</span>' + '</div></div>';
      }
      infowindow = new google.maps.InfoWindow({
        content: infoWindowContent
      });
    })
    google.maps.event.addListener(marker, 'click', function () {
      infowindow.open(this.googleMapObj, this);
    });
    this.markersArray.push(marker)
    if (emp.type == 'Branch') {
      this.googleMapObj.panTo(latLng);//for focusing marked location
    }
    if (emp.type == 'Branch') this.googleMapObj.setZoom(15);
  }

  clearOverlays() {
    for (var i = 0; i < this.markersArray.length; i++) {
      this.markersArray[i].setMap(null);
    }
    this.markersArray = [];
  }
  locationMarker(lat, lng) {
    if (this.locationMap != undefined) {
      this.markerId = 'pickLocation' + Math.round(Math.random() * 10000);
      lat = +lat.toFixed(5); lng = +lng.toFixed(5);
      this.locationMap.marker(
        {
          id: this.markerId,
          content: '<div class="mumb_marker_pin" style="background: #686ab9;"></div>',
          lat: lat,
          lng: lng,
        }
      );
      this.locationMap.focus({
        lat: lat,
        lng: lng,
        zoom: 14
      });
    }
  }
  closeMapModal() {
    if (this.selectedMap == 'google') {
      if (this.markersArray.length > 0) {
        this.clearOverlays();
      }
      if (this.plotPath) {
        this.plotPath.setMap(null);
      }
      this.empLocs = [];
      this.wayPoints = [];
    } else {
      this.locationMap.removeMarkerAll();
    }
    this.lineCoardinate = [];
    if (this.plottedLines.length > 0) {
      for (let i = 0; i < this.plottedLines.length; i++) {
        this.plottedLines[i].setMap(null);
      }
    }
    this.plottedLines = [];
  }

   //Add employee to route
  public groupingEmps: any = [];
  public availableGroupEmps: any = [];
  public storedGroupEmps: any = [];
  public showAddEmpTable: boolean = false;
  public addEmpGroup: any = {};
  public selectedEmployees: any = [];
  public availableSeats: number = 0;
  findGroupEmps(data) {
    if (data && data.length > 0) {
      let arr = [];
      for (let i = 0; i < data.length; i++) {
        if (this.selectedGroup.tripDate == data[i].tripDate && this.selectedGroup.transitMode == data[i].transitMode) {
          for (let j = 0; j < data[i]['empInfo'].length; j++) {
            data[i]['empInfo'][j]['oldRosterID'] = data[i]['rosterID'];
          }
          arr = [...arr, ...data[i]['empInfo']];
        }
      }
      this.groupingEmps = arr;
      this.showAddEmpTable = true;
    } else {
      this.groupingEmps = [];
    }
    this.availableGroupEmps = this.groupingEmps;
  }
  openAddEmp(group) {
    this.modalTitle = 'Add employee';
    this.statusFormSubmitted = false;
    this.isAnyChangesHere = false;
    if (group.escortInfo) {
      this.availableSeats = group.vehInfo.capacity - (group.empInfo.length + 1);
    } else {
      this.availableSeats = group.vehInfo.capacity - group.empInfo.length;
    }

    if (group.tripStatus === 'start') {
    const absentCount = group.empInfo.filter(
      emp => this.statusList[emp.empTripStatus] === 'No show'
    ).length;
    this.availableSeats += absentCount;
  }
  // console.log("availabel seats::::", this.availableSeats);
    this.addEmpGroup = group;
    this.findGroupEmps(this.storedGroupEmps);
    document.getElementById('openEmployeeAddBtn')?.click();
  }
  
  driverTripEnd(data: any) {
    this.endTripForm.reset();
    if ([undefined, 'roster'].includes(data['routeType'])) {
      let check = this.filterDataByStatus(data.empInfo, data);
      if (!check) {
        this.swal.swalFunction('info', '', 'Attendance should be marked before ending the trip!', 5000);
        return;
      } else {
        document.getElementById('openEndTripModalBtn')?.click();
      }
    }
    let routTypes = ['regular', 'openBooking', 'occasional']
    if (routTypes.includes(this.selectedGroup['routeType'])) {
      document.getElementById('openEndTripModalBtn')?.click();
    }
  }

  async tripEndFunction() {
    let routTypes = ['regular', 'openBooking', 'occasional']
    if (routTypes.includes(this.selectedGroup['routeType'])) {
      this.selectedGroup['start'] = {}
      this.selectedGroup['start']['value'] = this.selectedGroup['startingKM']
    }
    if (this.endTripForm.valid && (this.endTripForm.value.tripEndKlMtr > this.selectedGroup['start'].value)) {
      let end_time = new Date()
      let obj = {
        "vehRegNo": this.selectedGroup.vehRegNo,
        "location": { "lat": this.selectedGroup?.branchInfo?.location?.lat, "lng": this.selectedGroup?.branchInfo?.location?.lng },
        "driverInfo": {
          "name": this.selectedGroup.driverInfo.name,
          "mobile": this.selectedGroup.driverInfo.mobile ? this.selectedGroup.driverInfo.mobile : (this.selectedGroup.driverInfo.number
            ? this.selectedGroup.driverInfo.number
            : '---'),
          'driverID': this.selectedGroup.driverInfo['driverID']
        },
        "tripStatus": "end",
        "routeType": this.selectedGroup['routeType'],
        "tripDate": this.selectedGroup.tripDate,
        "tripStartTime": this.selectedGroup?.start ? this.selectedGroup['start']?.time : '',
        "time": end_time.getTime(),
        "value": this.endTripForm.value.tripEndKlMtr,
        "tripSheetID": "",
        "shiftTime": "",
        "empIDs": [],
        "title": "",
        "startingKM": this.selectedGroup['start'].value
      }

      if (routTypes.includes(this.selectedGroup['routeType'])) obj['routeID'] = this.selectedGroup['routeID'], obj['tripStartTime'] = this.selectedGroup['tripStartTime'];
      if ([undefined, 'roster'].includes(this.selectedGroup['routeType'])) obj['rosterID'] = this.selectedGroup['rosterID'];

      await this.selectedGroup?.empInfo?.map(async (emp: any) => {
        obj['empIDs'].push(emp?.employeeID)
      });
      this.api.transportManagertripEnd(obj).then((res: any) => {
        if (res.status == 'Success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.enTripModalBtn.nativeElement.click();
          this.endTripForm.reset();
        }
        if (res.status == 'failure') { this.swal.swalFunction(res.status, res.status, res.message, 2000); }
      });
    } else {
      this.endTripForm.markAllAsTouched();
      if (this.endTripForm.value['tripEndKlMtr'] && (this.endTripForm.value['tripEndKlMtr'] < this.selectedGroup['start'].value)) {
        this.endTripForm.controls.tripEndKlMtr.setErrors({ notValid: true })
      }
    }

  }
  ngOnDestroy(): void {
    this.clearInterval();
  }

  startInterval(): void {
    this.intervalId = setInterval(() => {
      this.refreshTrackingPage();
    }, 3 * 60 * 1000); // 3 * 60 * 1000  = 3 minutes
  }

  clearInterval(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

}